import ko from 'knockout';
import logger from '../../Vendor/inv-logger/logger';
import recaptchaHelper from '../Utils/recaptchaHelper';
import 'grecaptcha';

ko.bindingHandlers.recaptcha = {

  init: function (element, valueAccessor, allBindings) {

    var captchaValueAccessor = valueAccessor();

    var languageCode = allBindings.get('languageCode');
    var publicKey = allBindings.get('publicKey');
    var callback = allBindings.get('callback');

    var options = {
      'sitekey': publicKey,
      'hl': languageCode,
      'callback': function (captchaValue) {
        captchaValueAccessor(captchaValue);
        if (callback) {
          callback();
        }
      },
      'expired-callback': function () {
        captchaValueAccessor(null);
        if (callback) {
          callback();
        }
      }
    };

    // The Google reCAPTCHA externally hosted script conflicts using the same element as the Knockout
    // recaptcha binding is bound against and throws an error. To overcome this, create a child div for
    // the Google reCAPTCHA script to target.
    var recaptchaInnerDiv = document.createElement('div');
    element.appendChild(recaptchaInnerDiv);

    recaptchaHelper.getRecaptcha() // Returns a promise for the Google reCAPTCHA object
      .then(function (recaptchaObject) {
        recaptchaObject.render(recaptchaInnerDiv, options);
      })
      .catch(function (ex) {
        logger.error('CaptchaUnavailable', ex);
      });
  }
};
